<template lang="pug">
  #ProfilePhotoStickerComponent.profile_photoSticker.rounded-circle.m-auto.bg-white.position-relative
    .overflow-hidden.rounded-circle.d-flex.justify-content-center.position-relative.w-100.h-100
      b-img.w-100.h-100(
        :src="profileUrl ? profileUrl : 'xxx'",
        fluid,
        alt="Photo Sticker",
        :onerror="defaultPhotoSticker",
        style="object-fit: contain;"
      )
      //- 更換頭貼
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.changeProfileBtn(
        v-if="changeProfile",
        variant="danger"
        @click="changeProfileImgHandler()"
      )
        i.far.fa-image
    //- 叉叉
    b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.cancelProfileBtn(
      v-if="cancelProfile",
      variant="primary"
      @click="cancelProfileImgHandler()"
    )
      i.fas.fa-times
</template>

<script>
import defaultPhotoStickerUrl from '@/assets/images/default/defaultProfileImg.png';

export default {
  name: 'ProfilePhotoStickerComponent',
  props: {
    // 可有可無, 幫助判斷用
    id: {
      type: [String, Number]
    },
    profileUrl: {
      type: String,
      default: 'xxx'
    },
    // 更換大頭貼
    changeProfile: {
      type: Boolean,
      default: false
    },
    // 刪除選擇的大頭貼
    cancelProfile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`
    };
  },
  methods: {
    changeProfileImgHandler() {
      this.$emit('changeProfileImgHandler');
    },
    cancelProfileImgHandler() {
      this.$emit('cancelProfileImgHandler', this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.changeProfileBtn {
  position: absolute;
  bottom: 0;
  width: 30px;
  height: 30px;
}

.cancelProfileBtn {
  position: absolute;
  right: -5px;
  top: -5px;
  width: 20px;
  height: 20px;
}
</style>
